<template lang="pug">
  .category-post
    slot(name="header")
    component(:is="view")
    slot(name="footer")
</template>
<script>
import { mapGetters } from 'vuex';
import ContentPage from '@/views/ContentPage';
export default {
    name: 'CategoryPost',
    components: {
        ContentPage
    },
    computed: {
        ...mapGetters({
            view: 'view'
        })
    }
};
</script>
<style lang="sass" scoped></style>
